export var firebasConfig = {

 apiKey: "AIzaSyDpzb4xoWAUHO4Kn_pKMcYswqTntpRSfjA",
  authDomain: "bookflix-13166.firebaseapp.com",
  databaseURL: "https://bookflix-13166.firebaseio.com",
  projectId: "bookflix-13166",
  storageBucket: "bookflix-13166.appspot.com",
  messagingSenderId: "963170758268",
  appId: "1:963170758268:web:9f20defdc31993cc",
  measurementId: "G-6C2WMXRDQD"
};

export var AppInfo = {

Version: "1.0.49.20220107",

};


/*

 apiKey: "AIzaSyDpzb4xoWAUHO4Kn_pKMcYswqTntpRSfjA",
  authDomain: "bookflix-13166.firebaseapp.com",
  databaseURL: "https://bookflix-13166.firebaseio.com",
  projectId: "bookflix-13166",
  storageBucket: "bookflix-13166.appspot.com",
  messagingSenderId: "963170758268",
  appId: "1:963170758268:web:9f20defdc31993cc",
  measurementId: "G-6C2WMXRDQD"



apiKey: "AIzaSyBDjNLNbDs5V7UCEmSo__5xUSeNUUJd-z0",
  authDomain: "fcreder.firebaseapp.com",
  databaseURL: "https://fcreder.firebaseio.com",
  projectId: "fcreder",
  storageBucket: "fcreder.appspot.com",
  messagingSenderId: "70533644994"

  */



// WEBPACK FOOTER //
// ./src/app/credentials.ts